// Core
import styled, { css } from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Types
import { Theme } from '../../../../../../types/theme';
import {
  StatusIndicatorProps,
  StatusIndicatorStatus,
} from '../../../../../../layout/elements/StatusIndicator';

const borderColor = (
  { theme }: { theme: Theme },
) => theme.color.crusherDashboard.borderColor;

export const BinFeederContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  flex-direction: column;
  display: flex;
  height: 100%;
`;

export const RunningStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1.5rem;
  };
`;

export const RunningStatusList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    width: auto;
    flex: 1;
    gap: 1.25rem;
    justify-content: flex-end;
  };
`;

export const BinFeederTitleContainer = styled.div`
  display: flex;
  border-top: 1px solid ${borderColor};
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  width: 100%;
  align-items: center;
  border-radius: 4px 4px 0 0;
  padding: 0.75rem 1rem;
  margin-top: 1.25rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const BinFeederAutoModeContainer = styled.div`
  display: flex;
  border-top: 1px solid ${borderColor};
  border-bottom: 1px solid ${borderColor};
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  width: 100%;
  align-items: center;
  padding: 0.75rem 1rem;
  justify-content: space-between;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const ThermometerContainer = styled.div`
  display: flex;
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  border-bottom: 1px solid ${borderColor};
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.25rem;
  };
`;

export const PermissivesContainer = styled.div`
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  border-bottom: 1px solid ${borderColor};
  border-radius: 0 0 4px 4px;
  width: 100%;
`;

export const PermissiveTitleContainer = styled.div`
  padding: 0.75rem 1rem 0.625rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.125rem 1.25rem 0.625rem 1.25rem;
  };
`;

export const PermissiveListContainer = styled.ul<{ borderLeft?: boolean }>`
  list-style: none;
  margin: 0;
  padding: 0;

  ${({ borderLeft }) => borderLeft && css`
    padding: 0 0 1rem 0;
  `};

  @media (min-width: ${BREAKPOINTS.xl}px) {
    height: 100%;
    padding: 0 0 1.5rem 0;

    ${({ borderLeft }) => borderLeft && css`
      border-left: 1px solid ${borderColor};
    `};
  };
`;

export const PermissiveItem = styled.li<Pick<StatusIndicatorProps, 'status'>>`
  padding: 0.75rem 0 0.75rem 0.875rem;
  background-color: ${({ status, theme }) => (status !== StatusIndicatorStatus.alarm
    ? 'transparent'
    : theme.color.crusherDashboard.lubricationUnitDrawer.descriptionListErrorBackgroundColor
  )};
  border-radius: 4px;
  margin: 0 1rem 0 0.75rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    margin: 0 1.25rem 0 1.5rem;
  };
`;
